"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = require("styled-components");

/*
  Appcues can display a "Complete Setup" button on the screen. This button can overlap on
  mobile devices causing an issue when the modal is open where the user is unable to proceed.
  This fix will hide the complete setup button when the modal is open since it shouldn't display over modals anyways.
*/
var modalStyles = (0, _styledComponents.css)([".ui-modal-base--open{.appcues{display:none;}}"]);
var _default = modalStyles;
exports.default = _default;
//# sourceMappingURL=modal-styles.js.map